"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.keyedRecord = void 0;
function keyedRecord() {
    return function (obj) {
        return obj;
    };
}
exports.keyedRecord = keyedRecord;
//# sourceMappingURL=keyedRecord.js.map